import React, { useContext, useEffect, useRef, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import DeleteIcon from "../../svg/Delete";
import EditIcon from "../../svg/Edit";
import UserContext from "../../../utils/Contexts/UserContext";
import axiosInstance from "../../../utils/Requests/axios";
import toast from "react-hot-toast";
import AmericanExpressBrand from "../../svg/AmericanExpressBrand";
import Diners from "../../svg/Diners";
import DiscoverBrand from "../../svg/DiscoverBrand";
import EftPos from "../../svg/EftPos";
import Girocard from "../../svg/Girocard";
import JcbBrand from "../../svg/JcbBrand";
import MasterCardBrand from "../../svg/MasterCardBrand";
import UnionPayBrand from "../../svg/UnionPayBrand";
import VisaBrand from "../../svg/VisaBrand";
import Unknown from "../../svg/Unknown";
import AddCardModal from "../../../modals/AddCardModal";
import DeletePaymentModal from "../../../modals/DeletePaymentModal";

function SavedCards() {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { userData } = useContext(UserContext);
  const { themeStatus, paymentMethodTypes } = Constant();
  const [addedCards, setAddedCards] = useState(null);
  const [hoverItem, setHoverItem] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);

  const themeColor ="#3C8AFF"; 
  const addedCardsFetched = useRef(false);
  const getAddedCards = () => {
    if (addedCardsFetched.current) return;
    const url = `/users/${userData?.uuid}/cards`;
    axiosInstance
      .get(url)
      .then((response) => {
        setAddedCards(response?.data);
        addedCardsFetched.current = true;
      })
      .catch(() => {
        toast.error(t("There was an error fetching the saved cards data"));
      });
  };

  useEffect(() => {
    getAddedCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cardBrandConfig = {
    0: { label: "Unknown", Icon: Unknown },
    1: { label: "American Express", Icon: AmericanExpressBrand },
    2: { label: "Diners Club", Icon: Diners },
    3: { label: "Discover", Icon: DiscoverBrand },
    4: { label: "Eftpos Australia", Icon: EftPos },
    5: { label: "Girocard", Icon: Girocard },
    6: { label: "JCB", Icon: JcbBrand },
    7: { label: "MasterCard", Icon: MasterCardBrand },
    8: { label: "UnionPay", Icon: UnionPayBrand },
    9: { label: "Visa", Icon: VisaBrand },
  };
  const paymentMethods = [
    ...(Array.isArray(addedCards)
      ? addedCards.map((card) => {
          const brandLabel = cardBrandConfig[card?.brand]?.label || "Unknown";
          return {
            id: `card_${card.uuid}`,
            type: paymentMethodTypes.card,
            label: `${brandLabel} ****${card.last4}`,
            Icon: (props) => {
              const BrandIcon = cardBrandConfig[card?.brand]?.Icon || null;
              return BrandIcon ? (
                <BrandIcon {...props} fill={themeColor} />
              ) : null;
            },
            card, // Pass the card object for later use
          };
        })
      : []),
  ];

  return (
    <div
      id="SavedCards"
      className={`card cardSetting ${themeStatus?.[selectedTheme]}`}
    >
      <div className="card-header">
        <h4
          className="card-title responsive-title"
          style={{ fontWeight: "700" }}
        >
          {t("Saved Cards")}
        </h4>
      </div>

      <div className="card-body">
        <div className="d-flex flex-column justify-content-between">
          {!!paymentMethods.length &&
            paymentMethods?.map(({ id, label, Icon, card }, index) => (
              <div
                key={id}
                className={`my-2 pt-3 pb-0 pb-sm-3 pb-lg-2 bg-access-detail-dark rounded ${
                  card?.primary === true
                    ? "bg-soft-secondary"
                    : "bg-access-detail-dark"
                } rounded`}
              >
                <div className="px-3 py-0 ">
                  <div className="d-flex justify-content-between pb-3">
                    <Icon />

                    {card?.primary === true && (
                      <p
                        className="bg-soft-primary text-primary d-flex align-items-center justify-content-center"
                        style={{ margin: "unset", borderRadius: "5px", height:"29px", width:"90px" }}
                      >
                        {t("Primary")}
                      </p>
                    )}
                  </div>

                  <div className="d-flex justify-content-between flex-lg-row flex-column gap-2">
                    <div className="d-flex flex-lg-column flex-row justify-content-between align-items-center align-items-lg-start">
                      <h5 className={`${card?.primary ? "text-dark" : "text-white"} visa-label`}>{label}</h5>
                      <p
                        className={`${card?.primary ? "text-dark" : "text-white"} responsive-text`}
                        style={{ marginBottom: "unset" }}
                      >
                        {t("Expires")}{" "}
                        {`${card?.exp_month || ""}/${
                          card?.exp_year?.toString().slice(-2) || ""
                        }`}
                      </p>
                    </div>

                    <div className="d-flex gap-3 align-self-lg-end justify-content-between pb-3 pb-sm-1">
                      <button
                        className="btn btn-outline-primary button-save-edit align-items-center d-flex gap-1 justify-content-start justify-content-lg-center ps-1 ps-lg-0 pe-0"
                        onMouseEnter={() => setHoverItem(`ad-edit-${index}`)}
                        onMouseLeave={() => setHoverItem(null)}
                      >
                        <EditIcon
                          fill={
                            hoverItem === `ad-edit-${index}`
                              ? "#fff"
                              : "#377dff"
                          }
                        />
                        <span>{t("Edit")}</span>
                      </button>
                      <button
                        className="btn btn-outline-danger button-save-delete align-items-center d-flex gap-1 justify-content-start justify-content-lg-center ps-1 ps-lg-0 pe-0"
                        onClick={() => {
                          setSelectedCard({ ...card, label, id, Icon });
                        }}
                        onMouseEnter={() => setHoverItem(`ad-delete-${index}`)}
                        onMouseLeave={() => setHoverItem(null)}
                        data-bs-toggle="modal"
                        data-bs-target="#deletePaymentModal"
                      >
                        <DeleteIcon
                          stroke={
                            hoverItem === `ad-delete-${index}`
                              ? "#fff"
                              : "#ED4C78"
                          }
                        />
                        <span>{t("Delete")}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {/* <div
          className={`text-primary`}
          style={{ cursor: "pointer", marginTop: "1.3125rem" }}
          data-bs-toggle="modal"
          data-bs-target="#modalAddCard"
        >
          + {t("Add New Card")}
        </div> */}
      </div>
      <div className="card-header p-0"></div>
      <div className="d-flex justify-content-end card-body pt-3">
        <button
          className="btn btn-primary edit-profile-btn p-0"
        >
          {t("Save Changes")}
        </button>
      </div>
      <AddCardModal />
      <DeletePaymentModal card={selectedCard} setAddedCards={setAddedCards}/>
    </div>
  );
}

export default SavedCards;
